import { isDefined } from "@clipboard-health/util-ts";
import { Box, ThemeProvider } from "@mui/material";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { LoadingSpinner, PageHeaderWrapper } from "@src/appV2/redesign/system/ui-components";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { useParams } from "react-router-dom";

import {
  transformPlacementCandidateBanData,
  useGetPlacementCandidateBan,
} from "../../api/useGetPlacementCandidateBan";
import { BanDisputeStep, useDisputeBanSteps } from "../../hooks/useDisputeBanSteps";
import { BanDisputeForm } from "./DisputeBanForm";

interface BanDisputePageParams {
  banId?: string;
}

export function BanDisputePage() {
  const { banId } = useParams<BanDisputePageParams>();

  const {
    data: banResponse,
    isLoading: isLoadingBan,
    refetch: refetchBan,
  } = useGetPlacementCandidateBan({ banId: banId ?? "" }, { enabled: isDefined(banId) });
  const ban = banResponse ? transformPlacementCandidateBanData(banResponse) : undefined;

  const { currentStep, setCurrentStep, handleBack } = useDisputeBanSteps({
    ban,
    isLoadingBan,
  });

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        {(isLoadingBan || currentStep === undefined) && (
          <Box
            sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}
          >
            <LoadingSpinner size="medium" />
          </Box>
        )}
        {!isLoadingBan && ban && currentStep !== undefined && (
          <>
            <PageHeaderWrapper variant="tertiary">
              <PageHeaderTopRow
                title={`Step ${currentStep} of 3`}
                hideBackButton={currentStep === BanDisputeStep.CONFIRMATION}
                rightAction={
                  currentStep === BanDisputeStep.CONFIRMATION ? (
                    <IconButton iconType="close" variant="outlined" onClick={handleBack} />
                  ) : undefined
                }
                onClickBack={handleBack}
              />
            </PageHeaderWrapper>
            <Box sx={{ paddingX: 5, paddingTop: 4 }}>
              <BanDisputeForm
                banId={ban.id}
                workerId={ban.workerId}
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                onSubmitSuccess={refetchBan}
              />
            </Box>
          </>
        )}
      </PageWrapper>
    </ThemeProvider>
  );
}
